import React from 'react';
import OpsText from "./ops-text";

const OpsIcon = ({source, className, alt = "", size = "md", type = "menu", customType, text}) => {
    return (

        type === "menu" ?
            <div>
                <img src={source} className={`ops-icon-md ${className}`} alt={alt}/>
            </div>
            :
            type === "with-text" ?
                <div className="fa-flex-row align-items-center gap-1">
                    {source}
                    <OpsText type="label" color="color-1" alignment="left"
                             content={text}/>
                </div>
                :
                <div>
                    nic
                </div>
    );
};

export default OpsIcon;